<template>
  <div class="users-container">
    <el-input
      v-model="search"
      size="small"
      :placeholder="$t('app.pleaseEnterKeywordSearch')"
      style="width: 300px; margin-right: 20px"
    >
      <el-button
        slot="append"
        size="small"
        icon="el-icon-search"
        @click="getList()"
      ></el-button>
    </el-input>
    <el-button
      size="small"
      type="primary"
      icon="el-icon-plus"
      @click="handleNew()"
      >{{ $t("app.new") }}</el-button
    >
    <el-table :data="tableData" stripe style="width: 100%">
      <el-table-column align="left" :label="$t('app.operation')">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)">{{
            $t("app.bindRole")
          }}</el-button>
          <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)"
            >{{ $t("app.delete") }}</el-button
          >
        </template>
      </el-table-column>
      <el-table-column align="center" :label="$t('app.account')" prop="account">
      </el-table-column>
      <el-table-column
        align="center"
        :label="$t('app.username')"
        prop="username"
      >
      </el-table-column>
      <el-table-column align="right" :label="$t('app.enable')">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.enable"
            @change="userEnable(scope.row, scope.row.enable)"
          >
          </el-switch>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center; margin-top: 20px"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
    <el-dialog
      :title="$t('app.delete')"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span>{{ $t("app.isDelete") + "(" + deleteItem + ")" }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="info" @click="dialogVisible = false">{{
          $t("app.cancel")
        }}</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          @click="deleteUser()"
          >{{ $t("app.confirm") }}</el-button
        >
      </span>
    </el-dialog>
    <user-modal ref="userModal" @handleAdd="addUser"></user-modal>
    <roles-modal ref="rolesModal"></roles-modal>
  </div>
</template>

<script>
import UserModal from "./modules/UserModal";
import RolesModal from "./modules/RolesModal";
import {
  getUserList,
  enableUser,
  disableUser,
  deleteUser,
} from "@/api/systemManagement/userManagement";
export default {
  components: {
    UserModal,
    RolesModal,
  },
  data() {
    return {
      loading: false,
      size: 10,
      currentPage: 1,
      total: 100,
      dialogVisible: false,
      deleteItem: "",
      deleteIndex: "",
      tableData: [],
      search: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      getUserList({
        Account: this.search,
        PageIndex: this.currentPage,
        PageSize: this.size,
      }).then((res) => {
        this.total = res.data.Total;
        this.tableData = res.data.Items.map((item) => {
          return {
            account: item.Account,
            username: item.Name,
            enable: item.IsUse,
          };
        });
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleEdit(index, row) {
      this.$refs.rolesModal.edit(row);
    },
    handleDelete(index, row) {
      this.dialogVisible = true;
      this.deleteItem = row.account;
      this.deleteIndex = index;
    },
    deleteUser() {
      this.loading = true;
      deleteUser({ Account: this.deleteItem })
        .then(() => {
          this.loading = false;
          this.dialogVisible = false;
          this.tableData.splice(this.deleteIndex, 1);
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleNew() {
      this.$refs.userModal.new();
    },
    userEnable(row, val) {
      if (val) {
        enableUser({ Account: row.account })
          .then(() => {
            this.$notify({
              title: this.$t("app.success"),
              message: this.$t("app.opeSuccess"),
              type: "success",
            });
          })
          .catch(() => {
            row.enable = !val;
          });
      } else {
        disableUser({ Account: row.account })
          .then(() => {
            this.$notify({
              title: this.$t("app.success"),
              message: this.$t("app.opeSuccess"),
              type: "success",
            });
          })
          .catch(() => {
            row.enable = !val;
          });
      }
    },
    addUser(obj) {
      this.tableData.push(obj);
    },
  },
};
</script>
<style lang="scss" scoped>
.users-container {
  background-color: #fff;
  padding: 15px;
  border: solid 1px #ccc;
}
</style>
